import { render, staticRenderFns } from "./PerDrawMain.vue?vue&type=template&id=2543bcf4"
import script from "./PerDrawMain.vue?vue&type=script&lang=js"
export * from "./PerDrawMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports